import { faEdit, faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { faArrowLeft, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { toast } from 'react-toastify';
import { goalDelete } from '../../../../../../api/actions/goal/goal-delete';
import { CommentButton } from '../../../../../../components/comments/comment-button';
import { Button } from '../../../../../../components/shared/button/button';
import { LinkButton } from '../../../../../../components/shared/link-button/link-button';
import { Popup } from '../../../../../../components/shared/popup/popup';
import { basePerformError } from '../../../../../../helpers/error-helpers';
import { cutStr } from '../../../../../../helpers/string-helpers';
import { EntityTypes } from '../../../../../../models/enums/entity-types';
import { IGoal, GoalProcessTypes } from '../../../../../../models/goal';
import { GoalEditor } from './goal-editor';
import { getGoalFilePath } from '../../../../../../config/app-config';

interface IProps extends RouteComponentProps {
    narrativeUid: string,
    participantUid: string,
    title: string,
    goals: IGoal[],
    has: boolean,
    goal_process: GoalProcessTypes,
    reload(): void,
}

function GoalManagement(props: IProps) {

    const [editPopupVisible, setEditPopupVisible] = useState(false);
    const [editableEntity, setEditableEntity] = useState<IGoal>();
    const [entityForDelete, setEntityForDelete] = useState<IGoal>();

    return (<>
        <div className="list-title">
            <div>{props.title}:
                <strong> { ( props.goals && props.goals.length) || 0 }</strong>
            </div>
            <div>
                <Button
                    className="orange"
                    onClick={() => {
                        setEditableEntity(undefined);
                        setEditPopupVisible(true);
                    }}
                >
                    <FontAwesomeIcon icon={faPlus} /> <span>Add Goal</span>
                </Button>
            </div>
        </div>
        { props.goals && !!props.goals.length && (
            <table cellPadding="0" cellSpacing="0" className="list">
                <thead>
                    <tr>
                        <th>Description</th>
                        { props.has && props.goal_process === GoalProcessTypes.appraisal && (<th>Appraisal</th>) }
                        { props.has && props.goal_process === GoalProcessTypes.appraisal && (<th>Congruent</th>) }
                        <th>Icon</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.goals
                        .sort((i1, i2) => i1.description > i2.description ? 1 : (i1.description < i2.description ? -1 : 0) )
                        .map((el: IGoal) => (
                            <tr key={el.uid}>
                                <td>
                                    {el.description}
                                </td>
                                { props.has && props.goal_process === GoalProcessTypes.appraisal && (<td>
                                    {el.appraisal && el.appraisal.description}
                                </td>)}
                                { props.has && props.goal_process === GoalProcessTypes.appraisal && (<td>
                                    {el.congruent === undefined ? undefined : (el.congruent ? 'Yes' : 'No')}
                                </td>)}
                                <td>
                                {el.fileName ? (
                                    <img
                                    src={getGoalFilePath(
                                        el.uid,
                                        el.fileName
                                    )}
                                    alt={el.description}
                                    style={{ width: '50px', height: '50px' }}
                                    />
                                ) : (
                                    'No Image'
                                )}
                                </td>
                                <td>
                                    <LinkButton
                                        onClick={() => {
                                            setEditableEntity(el);
                                            setEditPopupVisible(true);
                                        } }
                                    >
                                        <FontAwesomeIcon icon={faEdit} /> Edit
                                    </LinkButton><br />
                                    <LinkButton
                                        className="red"
                                        onClick={async () => {
                                            setEntityForDelete(el);
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faTrashAlt} /> Delete
                                    </LinkButton><br />
                                    <CommentButton
                                        isLink={true}
                                        entityType={EntityTypes.goal}
                                        entityUid={el.uid}
                                        taskEntityType={EntityTypes.narrative}
                                        taskEntityUid={props.narrativeUid}
                                    />
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        )}

        { editPopupVisible && (
            <Popup
                title={editableEntity ? 'Edit Goal' : 'Add Goal'}
                modal={true}
            >
                <GoalEditor
                    uid={editableEntity?.uid}
                    onClose={() => setEditPopupVisible(false)}
                    has={props.has}
                    goal_process={props.goal_process}
                    participantUid={props.participantUid}
                    reload={props.reload}
                />
            </Popup>
        )}

        { entityForDelete && (
            <Popup
                modal={true}
                className="red"
                title="Delete Goal"
                onClose={() => setEntityForDelete(undefined) }
                buttons={[
                    {
                        title: <><FontAwesomeIcon icon={faArrowLeft} /> <span>Cancel</span></>,
                        className: 'gray',
                        onClick: () => setEntityForDelete(undefined),
                    },
                    {
                        title: <><span>Delete</span> <FontAwesomeIcon icon={faTrashAlt} /></>,
                        className: 'red',
                        onClick: async () => {
                            try {
                                const result = await goalDelete(entityForDelete.uid);
                                if(result.success) {
                                    props.reload();
                                    toast.success('Item has been successfully deleted');
                                    setEntityForDelete(undefined);
                                }
                            }
                            catch(err) {
                                basePerformError(err, props.history);
                            }
                        },
                    },
                ]}
            >
                Are you sure want to delete goal: <strong>{cutStr(entityForDelete.description)}</strong>?
            </Popup>
        )}
    </>);
}

const GoalManagementWithRouter = withRouter(GoalManagement);
export { GoalManagementWithRouter as GoalManagement };
